<template>
  <div class="panel-div" style="position: relative;">
    <v-card flat class="d-flex flex-column panel assessment-light panel-opaque" style="position: relative">
      <v-card-title id="prompt" class="question-prompt justify-center d-flex">
        {{ $t('app.user_interface.edit.title') }}
      </v-card-title>
      <v-card-text>
        <div>
          <h3 class="font-weight-bold mb-1 assessment-light">{{ $t('app.user_interface.heart_rate_input_method.title') }}
          </h3>
          <v-radio-group v-model="heartRateInput" row class="custom-radio-group" @change="onHeartRateInputChange">
            <v-radio :label="$t('app.user_interface.tapper.title')" value="tapper" class="custom-radio"
              color="primary"></v-radio>
            <v-radio :label="$t('app.user_interface.slider.title')" value="slider" class="custom-radio"
              color="primary"></v-radio>
          </v-radio-group>
        </div>
        <v-divider class="mb-6" color="var(--primary-blue)"></v-divider>
        <div>
          <h3 class="font-weight-bold mb-1 assessment-light">
            {{ $t('app.user_interface.respiratory_rate_input_method.title') }}</h3>
          <v-radio-group v-model="respiratoryRateInput" row class="custom-radio-group"
            @change="onRespiratoryRateInputChange">
            <v-radio :label="$t('app.user_interface.tapper.title')" value="tapper" class="custom-radio"
              color="primary"></v-radio>
            <v-radio :label="$t('app.user_interface.slider.title')" value="slider" class="custom-radio"
              color="primary"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'UserInterface',
  data() {
    return {
      heartRateInput: null,
      respiratoryRateInput: null,
    }
  },
  methods: {
    onHeartRateInputChange(newValue) {
      this.heartRateInput = newValue;
      this.$store.commit('v4/preference/setHeartRateInputMethod', newValue)
    },
    onRespiratoryRateInputChange(newValue) {
      this.respiratoryRateInput = newValue;
      this.$store.commit('v4/preference/setRespiratoryRateInputMethod', newValue)
    }
  },
  mounted() {
    this.heartRateInput = this.$store.getters['v4/preference/getHeartRateInputMethod'];
    this.respiratoryRateInput = this.$store.getters['v4/preference/getRespiratoryRateInputMethod'];
  }
}
</script>
<style scoped>
.question-prompt {
  font-weight: 600;
  size: 18px;
  line-height: 1.1em;
  background-color: var(--deep-blue);
  color: white;
  margin-bottom: 2rem;
}

.panel-div {
  width: 100%;
  margin: 1.2rem;
}

.rounded-b-0 {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.v-card {
  overflow: hidden;
}

.v-btn {
  outline-color: var(--deep-blue);
  outline-width: 2px;
  outline-style: solid;
}

.v-btn.v-btn--disabled {
  outline-color: var(--primary-blue-30);
  outline-width: 2px;
  outline-style: solid;
}

.custom-radio-group {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100%;
}

.custom-radio {
  margin-right: 16px;
}

.custom-radio :deep(.v-radio) {
  opacity: 1;
}

.custom-radio :deep(.v-selection-control__input) {
  opacity: 1;
}

.custom-radio :deep(.v-icon) {
  opacity: 0.6;
  color: var(--dark-grey, #666);
}

.custom-radio :deep(.v-selection-control--dirty .v-icon) {
  opacity: 1;
  color: var(--primary-blue, #1976D2);
}

.custom-radio :deep(.v-label) {
  opacity: 1;
  color: rgba(0, 0, 0);
  font-weight: 500;
}

.custom-radio :deep(.v-radio:hover .v-icon) {
  opacity: 0.8;
}
</style>